// extracted by mini-css-extract-plugin
export default {"carouselContainer":"NewsCarousel_carouselContainer__6WAbF","slide":"NewsCarousel_slide__adEwY","link":"NewsCarousel_link__3neRv","image":"NewsCarousel_image__AM76L"};